import { Point, LineString, Polygon } from 'ol/geom';
import { Feature } from 'ol';
import { fromLonLat } from 'ol/proj';

export const ToFeaturesFlat = (sourceItems) => {
    var features = sourceItems.map((source) => source.items.map((item) => {
        if (source.typeName)
            item.typeName = source.typeName;
        if (source.fillColor)
            item.fillColor = source.fillColor;
        return new Feature({
            properties: item,
            geometry: new Point(fromLonLat([item.x, item.y])),
        })
    })).flat();
    // var features = items.map((item) =>
    // {
    //     if(typeName)
    //         item.typeName = typeName;
    //     return new Feature({
    //         properties: item,
    //         geometry: new Point(fromLonLat([item.x, item.y])),
    //     })
    // }
    // );

    return features;
}

export const ToFeatures = (items, addOptions) => {
    var features = items.map((item) => {
        if (addOptions) {
            Object.keys(addOptions).forEach((key) => {
                item[key] = addOptions[key]
            });
        }
        return new Feature({
            properties: item,
            geometry: new Point(fromLonLat([item.x, item.y])),
        })
    });

    return features;
}

export const ToPolylineFeature = (points) => {
    return new Feature({
        geometry: new LineString(points.map(item => fromLonLat(item))),
    })
}

export const ToPolygonFeature = (prop, points) => {
    return new Feature({
        properties: prop,
        geometry: new Polygon([points.map(item => fromLonLat(item))]),
    })
}